<template>
    <div component="VideoProjects">
        <page-header :icon="'view_module'" :text="'My Projects'" />
        <section container="detail">
            <!--            <header>-->
            <!--                <div class="cell name">PROJECT / CHARACTER</div>-->
            <!--                <div class="cell client">CLIENT / DATE</div>-->
            <!--                <div class="cell status">STATUS</div>-->
            <!--            </header>-->
            <section>
                <div v-bar class="vb">
                    <div>
                        <video-project-item v-for="(item, index) in videoRequests" :videoRequest="item" :key="index" />
                    </div>
                </div>
            </section>
        </section>
    </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import moment from 'moment';
import VideoProjectItem from './VideoProjectItem.vue';
import PageHeader from '@/components/Profile/ProfileDetailHeader.vue';

export default {
    name: 'VideoProjects',

    data() {
        return {
            // videoRequests: [], // Main list
            videoRecorderDialog: false,
            videoDialog: false,
            video_hash: null,
            video_url: null,
            selected_video_request: {
                videos: [],
            },
            video_key: 0,
        };
    },

    async mounted() {
        await this.loadActorVideoRequests({
            include: ['project', 'project.client', 'emailRequests', 'emailRequests.videos', 'character'],
        });
    },

    computed: {
        ...mapGetters(['getActor']),

        videoRequests() {
            return this.getActor.videoRequests;
        },
    },

    methods: {
        ...mapActions(['loadVideo', 'loadActorVideoRequests']),

        getDateWithTime(date) {
            return `${moment(date).format('DD. MM. YYYY')}`;
        },

        startRecording(video) {
            this.video_hash = video.hash;
            this.videoRecorderDialog = true;
        },

        async showRecording(video_request) {
            this.selected_video_request = video_request;
            this.videoDialog = true;
        },

        async loadSelectedVideo(video) {
            const base64_vid = await this.loadVideo(video.hash);
            this.video_url = `data:video/webm;base64,${base64_vid}`;
            this.video_key++;
        },

        closeVideoPreview() {
            this.$refs.video.pause();
            this.videoDialog = false;
            this.video_url = null;
        },
    },

    components: {
        VideoProjectItem,
        PageHeader,
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='VideoProjects'] {
    height: 100%;
    display: flex;
    flex-direction: column;

    section {
        overflow-y: auto;
        flex-grow: 1;
        height: 100%;
    }

    .cell {
        padding: 5px 0;
        font-size: 13px;

        &.name {
            flex: 1;
        }

        &.status {
            width: 103px;
            padding: 5px 10px;
        }

        &.client {
            width: 130px;
            padding: 5px 10px;
        }

        &.date {
            width: 80px;
            text-align: left;
            padding-right: 10px;
        }
    }

    header {
        width: 100%;
        display: flex;
        text-transform: uppercase;
        font-weight: 900;
        border-bottom: 1px solid @black;

        .type {
            padding-right: 10px;
        }
    }
}
</style>
